import { all, put, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import {
    GET_CATERING_TASKS_LIST,
    GET_CATERING_TASKS_LIST_FAILURE,
    GET_CATERING_TASKS_LIST_SUCCESS,
} from '../../../modules/constants';
import { defaultApi } from '../../../utils/axiosApi';

export function* handleGetCateringTasksList({ payload }) {
    const {
        startDate,
        endDate,
        page,
        task_name,
        location_id,
        assignee_id,
        status,
    } = payload;
    try {
        const url = `/tasks/catering-tasks/?required_start_date=${startDate}&required_end_date=${endDate}${page ? `&page=${page}` : ''
            }${task_name ? `&name=${task_name}` : ''}${location_id ? `&location_id=${location_id}` : ''
            }${assignee_id ? `&assignees=${assignee_id}` : ''}${status ? `&status=${status}` : ''
            }`;
        const response = yield defaultApi(url, 'GET', payload);
        yield put({
            type: GET_CATERING_TASKS_LIST_SUCCESS,
            payload: { data: response.data },
        });
    } catch (err) {
        yield put({
            type: GET_CATERING_TASKS_LIST_FAILURE,
            payload: err,
        });
    }
}

export default function* root() {
    yield all([
        takeLatest(GET_CATERING_TASKS_LIST, handleGetCateringTasksList),
    ]);
}
